<section id="content1" class="fbo-tab-content quicklink-sidebar">
    <div class="row">
        <div class="col-sm-6 col-md-1 padding-top10">
            <div>
                <img src="{{retailProfileInformation.profileImageURL}}" alt="" class="img-rounded img-responsive" />
            </div>
        </div>
        <div class="col-sm-8 col-md-10">
            <div>
                <ul class="col-sm-12 list-group orderdet-column clearfix" style="padding-right:0;">
                    <li class="retail-list-group-item margin-10 col-xs-4 col-md-6">
                        <div class="heading-block">{{'customer-service.Personal Information' |translate}}</div>
                        <div class="row">
                            <div class="col-xs-6 col-sm-4 col-md-5">
                                <label>{{'customer-service.Full Name' |translate}}</label>
                            </div>
                            <div class="col-xs-6 col-sm-6">
                                : &nbsp; {{retailProfileInformation.firstName}} {{retailProfileInformation.lastName?(' ' + retailProfileInformation.lastName)
                                : ''}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-6 col-sm-4 col-md-5">
                                <label>{{'customer-service.ID' |translate}}</label>
                            </div>
                            <div class="col-xs-6 col-sm-6">
                                : &nbsp;{{retailProfileInformation.userName}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-6 col-sm-4 col-md-5">
                                <label>{{'customer-service.Level' |translate}}</label>
                            </div>
                            <div class="col-xs-6 col-sm-6">
                                : &nbsp;{{retailProfileInformation.memberLevel}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-6 col-sm-4 col-md-5">
                                <label class="">{{'customer-service.Status' |translate}}</label>
                            </div>
                            <div class="col-xs-6 col-sm-6">
                                : &nbsp;{{retailProfileInformation.status}}
                            </div>
                        </div>
                        <div class="heading-block">{{'customer-service.Contact Information' |translate}}</div>
                        <div class="row">
                            <div class="col-xs-6 col-sm-4 col-md-5">
                                <label>{{'customer-service.Email Address' |translate}}
                                     &nbsp;<i class="glyphicon glyphicon-envelope"></i>
                                </label>
                            </div>
                            <div class="col-xs-6 col-sm-6 col-md-7">
                                : &nbsp;{{retailProfileInformation.emailId}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-6 col-sm-4 col-md-5">
                                <label>{{'customer-service.Phone Number' |translate}}
                                     &nbsp;<i class="glyphicon glyphicon-phone"></i>
                                </label>
                            </div>
                            <div class="col-xs-6 col-sm-6 col-md-7">
                                : &nbsp; {{retailProfileInformation.homePhoneNumber}}
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-6 col-sm-4 col-md-5">
                                <label class="">{{'customer-service.Address' |translate}}</label>
                            </div>
                            <div class="col-xs-6 col-sm-6 col-md-7">
                                : &nbsp;{{retailProfileInformation.address.addressFirstLine}} {{retailProfileInformation.address.addressSecondLine? (', '+retailProfileInformation.address.addressSecondLine)
                                : ''}} {{retailProfileInformation.address.city? (',' + retailProfileInformation.address.city)
                                : ''}} {{retailProfileInformation.address.state? (', ' +retailProfileInformation.address.state)
                                : ''}} {{retailProfileInformation.address.zipCode? (', '+retailProfileInformation.address.zipCode)
                                : ''}} &nbsp; {{retailProfileInformation.address.country}}
                                <i class="glyphicon glyphicon-map-marker"></i>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-6 col-sm-4 col-md-5">
                                <label>{{'customer-service.Language Preferences' |translate}}</label>
                            </div>
                            <div class="col-xs-6 col-sm-6">
                                : &nbsp;{{retailProfileInformation.preferredLanguage}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-6 col-sm-4 col-md-5">
                                <label>{{'customer-service.Store Eligibility' |translate}}</label>
                            </div>
                            <div class="col-xs-6 col-sm-6">
                                : &nbsp;
                                <span *ngFor="let store of retailProfileInformation.storeEligibility; let i = index; let count = count;">
                                    {{store + ((i < count - 1) ? ', ' : '.')}} </span>
                            </div>
                        </div>
                    </li>
                    <li class="retail-list-group-item margin-10 col-xs-4 col-md-5">
                        <div class="heading-block">{{'customer-service.Default Payment Method' |translate}}</div>
                        <div class="text-center">
                            <div>{{retailProfileInformation.cardName}}</div>
                            <div>{{retailProfileInformation.cardNumber}} </div>
                            <div>{{retailProfileInformation.expireDate}}</div>
                        </div>
                    </li>
                    <li class="retail-list-group-item margin-10 col-xs-4 col-md-5">
                        <div class="heading-block">{{'customer-service.Referring FBO' |translate}}</div>
                        <div class="row">
                            <div class="col-xs-6 col-sm-4 col-md-6">
                                <label>{{'customer-service.Full Name' |translate}}</label>
                            </div>
                            <div class="col-xs-6 col-sm-6">
                                : &nbsp;{{retailProfileInformation.sponsorDetails.firstName}} {{retailProfileInformation.lastName? (' '+ retailProfileInformation.sponsorDetails.lastName):''}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-6 col-sm-4 col-md-6">
                                <label>{{'customer-service.ID' |translate}}</label>
                            </div>
                            <div class="col-xs-6 col-sm-6">
                                : &nbsp;{{retailProfileInformation.sponsorDetails.fboId}}
                            </div>
                        </div>
                    </li>
                    <li class="retail-list-group-item margin-10 col-xs-4 col-md-5">
                        <div class="heading-block">{{'customer-service.Purchase Details' |translate}}</div>
                        <div class="row">
                            <div class="col-xs-6 col-sm-4 col-md-6">
                                <label>{{'customer-service.First Purchase Date' |translate}}</label>
                            </div>
                            <div class="col-xs-6 col-sm-6">
                                : &nbsp;{{retailProfileInformation.firstPurchaseDate|date:'dd-MMM-yyyy'}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-6 col-sm-4 col-md-6">
                                <label>{{'customer-service.Birth Date' |translate}}</label>
                            </div>
                            <div class="col-xs-6 col-sm-6">
                                : &nbsp;{{retailProfileInformation.birthDate|date:'dd-MMM-yyyy'}}
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <div class="col-md-1" *ngIf="(impersonationPermission | hasAccess : customerServiceAccessLevelId)">
            <button class="btn btn-link  site-login" tabindex="0" (keyup.enter)="impersonate(retailProfileInformation.userName)" (click)="impersonate(retailProfileInformation.userName)">{{'customer-service.Retail Login' |translate}}</button>
        </div>

    </div>
</section>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/retail-profile.component.html